import React, { useEffect } from 'react';
import modisIcon from '../../../assets/icons/modis-icon-black.png';
import viirsIcon from '../../../assets/icons/viirs-icon-black.png';
import rawsIcon from '../../../assets/icons/raws-icon-black.png';
import predictionIcon from '../../../assets/icons/alert-png.png';
import '../Widgets.scss';
import { useSensorDataContext } from '../../../contexts/SensorDataContext';
import Tooltip from "@mui/material/Tooltip";
import EmergencyStations from './EmergencyStations';
import PowerPlants from './PowerPlants';
import SatelliteLayers from './SatelliteLayers';
import FeatureLayerWidget from './FeatureLayerWidget';
import satelliteIcon from '../../../assets/icons/satellite-icon-2.png';
import planeIcon from '../../../assets/icons/plane-icon-black.png';

export default function MapSensorDataWidgets(props) {
    const {
        map,
        satelliteLayers,
        setSatelliteLayers,
        selectedSatelliteLayer,
        setSelectedSatelliteLayer,
        satellites,
        flights
    } = props;

    const {
        predictions,
        raws,
        viirs,
        modis,
        layers,
        setLayers
    } = useSensorDataContext();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
            <EmergencyStations 
                map={map}
            />
            <PowerPlants
                map={map}
            />
            <Tooltip 
                title="Real-time wildifre predictions powered by advanced AI and machine learning algorithms." 
                arrow
                placement='left'
            >
                <div 
                    className={!predictions ? 'weather-widgets-widget-disabled' : layers.predictions === false ? 'weather-widgets-widget' : 'weather-widgets-widget-active'}
                    onClick={() => {
                            setLayers({
                                ...layers,
                                predictions: !layers.predictions
                            })

                            const selected = map.current.getStyle().layers.filter((l) => l.id.includes('Layer-Prediction-symbol'))[0];
                            
                            if (layers.predictions) {
                                map.current.setLayoutProperty(selected.id, 'visibility', 'none');
                            } else {
                                map.current.setLayoutProperty(selected.id, 'visibility', 'visible');
                            }
                     
                    }}
                >
                    <div className={!predictions ? 'weather-widgets-widget-disabled-title' : layers.predictions === false ? 'weather-widgets-widget-title' : 'weather-widgets-widget-active-title'}>Wildfire Predictions</div>
                    <div className='weather-widgets-widget-img-container'>
                        <img 
                            src={predictionIcon} 
                            className='weather-widgets-widget-img'
                        />
                    </div>
                </div>
            </Tooltip>
            <SatelliteLayers map={map} satelliteLayers={satelliteLayers} setSatelliteLayers={setSatelliteLayers} selectedSatelliteLayer={selectedSatelliteLayer} setSelectedSatelliteLayer={setSelectedSatelliteLayer}/>
            <Tooltip 
                title="Satellites specializing in disaster monitoring, weather/climate, Earth resources, and more, along with it's path." 
                arrow
                placement='left'
            >
                <div 
                    className={!satellites ? 'weather-widgets-widget-disabled' : layers.satellites === false ? 'weather-widgets-widget' : 'weather-widgets-widget-active'}
                    onClick={() => {
                            setLayers({
                                ...layers,
                                satellites: !layers.satellites
                            })

                            const selected = map.current.getStyle().layers.filter((l) => l.id.includes('Layer-satellites-icons'))[0];
                            
                            if (layers.satellites) {
                                map.current.setLayoutProperty(selected.id, 'visibility', 'none');
                            } else {
                                map.current.setLayoutProperty(selected.id, 'visibility', 'visible');
                            }
                    }}
                >
                    <div className={!satellites ? 'weather-widgets-widget-disabled-title' : layers.satellites === false ? 'weather-widgets-widget-title' : 'weather-widgets-widget-active-title'}>Oribitting Satellites</div>
                    <div className='weather-widgets-widget-img-container'>
                        <img 
                            src={satelliteIcon} 
                            className='weather-widgets-widget-img'
                        />
                    </div>
                </div>
            </Tooltip>
            <Tooltip 
                title="Aircrafts specializing in fire containment, along with their path." 
                arrow
                placement='left'
            >
                <div 
                    className={!flights ? 'weather-widgets-widget-disabled' : layers.flights === false ? 'weather-widgets-widget' : 'weather-widgets-widget-active'}
                    onClick={() => {
                            setLayers({
                                ...layers,
                                flights: !layers.flights
                            })

                            const selected = map.current.getStyle().layers.filter((l) => l.id.includes('flights'));
                            
                            if (layers.flights) {
                                selected.forEach((s) => {
                                    map.current.setLayoutProperty(s.id, 'visibility', 'none');
                                })
                            } else {
                                selected.forEach((s) => {
                                    map.current.setLayoutProperty(s.id, 'visibility', 'visible');
                                })
                            }
                    }}
                >
                    <div className={!flights ? 'weather-widgets-widget-disabled-title' : layers.flights === false ? 'weather-widgets-widget-title' : 'weather-widgets-widget-active-title'}>Firefighting Aircrafts</div>
                    <div className='weather-widgets-widget-img-container'>
                        <img 
                            src={planeIcon} 
                            className='weather-widgets-widget-img'
                        />
                    </div>
                </div>
            </Tooltip>
            <Tooltip 
                title="RAWS (Remote Automated Weather Stations) weather data provides real-time environmental information primarily used for fire weather monitoring and management." 
                arrow
                placement='left'
            >
                <div 
                    className={!raws ? 'weather-widgets-widget-disabled' : layers.raws === false ? 'weather-widgets-widget' : 'weather-widgets-widget-active'}
                    onClick={() => {
                        if (raws) {
                            setLayers({
                                ...layers,
                                raws: !layers.raws
                            })

                            const selected = map.current.getStyle().layers.filter((l) => l.id.includes('Layer-RAWS-symbol'))[0];
                            
                            if (layers.raws) {
                                map.current.setLayoutProperty(selected.id, 'visibility', 'none');
                            } else {
                                map.current.setLayoutProperty(selected.id, 'visibility', 'visible');
                            }
                        }
                    }}
                >
                    <div className={!raws ? 'weather-widgets-widget-disabled-title' : layers.raws === false ? 'weather-widgets-widget-title' : 'weather-widgets-widget-active-title'}>RAWS Weather Stations</div>
                    <div className='weather-widgets-widget-img-container'>
                        <img 
                            src={rawsIcon} 
                            className='weather-widgets-widget-img'
                        />
                    </div>
                </div>
            </Tooltip>
            <Tooltip
                title='Highlights fire hotspots detected by the Visible Infrared Imaging Radiometer Suite (VIIRS) for monitoring active fires.'
                arrow
                placement='left'
            >
                <div 
                    className={!viirs ? 'weather-widgets-widget-disabled' : layers.viirs === false ? 'weather-widgets-widget' : 'weather-widgets-widget-active'}
                    onClick={() => {
                        if (viirs) {
                            setLayers({
                                ...layers,
                                viirs: !layers.viirs
                            })

                            const selected = map.current.getStyle().layers.filter((l) => l.id.includes('Layer-VIIRS-heatmap'))[0];
                            
                            if (layers.viirs) {
                                map.current.setLayoutProperty(selected.id, 'visibility', 'none');
                            } else {
                                map.current.setLayoutProperty(selected.id, 'visibility', 'visible');
                            }
                        }
                    }}
                >
                    <div className={!viirs ? 'weather-widgets-widget-disabled-title' : layers.viirs === false ? 'weather-widgets-widget-title' : 'weather-widgets-widget-active-title'}>VIIRS Thermal Hotspots</div>
                    <div className='weather-widgets-widget-img-container'>
                        <img 
                            src={viirsIcon} 
                            className='weather-widgets-widget-img'
                        />
                    </div>
                </div>
            </Tooltip>
            <Tooltip
                title='Displays fire detections from the Moderate Resolution Imaging Spectroradiometer (MODIS), useful for tracking fire locations and intensity.'
                arrow
                placement='left'
            >
                <div 
                    className={!modis ? 'weather-widgets-widget-disabled' : layers.modis === false ? 'weather-widgets-widget' : 'weather-widgets-widget-active'}
                    onClick={() => {
                        if (modis) {
                            setLayers({
                                ...layers,
                                modis: !layers.modis
                            })

                            const selected = map.current.getStyle().layers.filter((l) => l.id.includes('Layer-MODIS-heatmap'))[0];
                            
                            if (layers.modis) {
                                map.current.setLayoutProperty(selected.id, 'visibility', 'none');
                            } else {
                                map.current.setLayoutProperty(selected.id, 'visibility', 'visible');
                            }
                        }
                    }}
                >
                    <div className={!modis ? 'weather-widgets-widget-disabled-title' : layers.modis === false ? 'weather-widgets-widget-title' : 'weather-widgets-widget-active-title'}>MODIS Thermal Hotspots</div>
                    <div className='weather-widgets-widget-img-container'>
                        <img 
                            src={modisIcon} 
                            className='weather-widgets-widget-img'
                        />
                    </div>
                </div>
            </Tooltip>
        </div>
    )
}